//Temporada actual
export const CURRENT_SEASON = 101
//Id's competicones
export const ID_PRIMERA_DIVISION = 1
export const ID_SEGUNDA_DIVISION = 2
export const ID_PRIMERA_DIVISION_FEMENINA = 15
